import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col /* Alert */ } from "react-bootstrap";
// import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import ItemService from "../../../../services/customer_appCommonService";

const CommonFilterCustomerV2 = (props) => {
  const { getfiltereddata, onSubmit } = props; // Access the filtered data passed as a prop
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getCustomer, setCustomer] = useState([]);

  const months = [
    { id: 1, name: "January", code: 1 },
    { id: 2, name: "February", code: 2 },
    { id: 3, name: "March", code: 3 },
    { id: 4, name: "April", code: 4 },
    { id: 5, name: "May", code: 5 },
    { id: 6, name: "June", code: 6 },
    { id: 7, name: "July", code: 7 },
    { id: 8, name: "August", code: 8 },
    { id: 9, name: "September", code: 9 },
    { id: 10, name: "October", code: 10 },
    { id: 11, name: "November", code: 11 },
    { id: 12, name: "December", code: 12 },
  ];

  // const years = [
  //   { id: 2025, name: "2025", code: 2025 },
  //   { id: 2024, name: "2024", code: 2024 },
  //   { id: 2023, name: "2023", code: 2023 },
  //   { id: 2022, name: "2022", code: 2022 },
  //   { id: 2021, name: "2021", code: 2021 },
  //   { id: 2020, name: "2020", code: 2020 },
  //   { id: 2019, name: "2019", code: 2019 },
  //   { id: 2018, name: "2018", code: 2018 },
  //   { id: 2017, name: "2017", code: 2017 },
  //   { id: 2016, name: "2016", code: 2016 },
  // ];

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: currentYear - 2020 + 1 }, (_, index) => {
    const year = currentYear - index;
    return {
      id: year,
      name: year.toString(),
      code: year,
    };
  });
  const [getFilterData, setFilterData] = useState();
  const [getDropdownData, setDropdownData] = useState("");

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: 1,
      action: "",
      value: "",
    },
  ]);

  useEffect(() => {
    if (!getDropdownData || !getDropdownData.index) return;

    setcustomerContactPerson((prev) =>
      prev.map((doc) => {
        if (doc.id !== getDropdownData.index) return doc;

        // For actionCode or userId
        if (
          getDropdownData?.textCode === "actionCode" ||
          getDropdownData?.textCode === "userId"
        ) {
          return {
            ...doc,
            [getDropdownData.textField]: getDropdownData.name,
            [getDropdownData.textCode]: getDropdownData.id,
          };
        }

        if (
          getDropdownData?.textField === "month" ||
          getDropdownData?.textField === "years"
        ) {
          return {
            ...doc,
            [getDropdownData.textField]: getDropdownData.code,
          };
        }

        if (getDropdownData?.textCode === "companyCode") {
          customerDataDropdown(getDropdownData?.id);

          return {
            ...doc,
            //      [getDropdownData?.textField]: getDropdownData?.name,
            // [getDropdownData?.textCode]: getDropdownData?.id,
            [getDropdownData?.textField]: getDropdownData?.description,
          };
        }

        return doc;
      }),
    );
  }, [getDropdownData]);
  const customerDataDropdown = async (code) => {
    let obj = {
      companyCode: code,
    };

    await ItemService.getCustomersByCompany(obj).then((item) => {
      if (item?.status === 200) {
        setCustomer(item?.data);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };
  useEffect(() => {
    loadMasterData();
  }, []);
  const extractIds = () => {
    const filtered = getfiltereddata
      .filter((col) => col.id)
      .map((col) => ({ id: col.id, name: col.name }));
    setFilterData(filtered);
  };

  // Call once when needed, e.g., on mount
  useEffect(() => {
    extractIds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancel = () => {
    props.cancelAction();
  };

  const handleClearAll = () => {
    setcustomerContactPerson([
      {
        id: Date.now(),
        action: "",
        value: "",
      },
    ]);
  };
  // const [customerContactPerson, setCustomerContactPerson] = useState([]);

  const [validation, setValidation] = useState({});

  const handleSubmit = () => {
    let errors = {};

    getcustomerContactPerson.forEach((doc) => {
      // Check for date range validation
      if (
        doc.actionCode === "createdAt" ||
        doc.actionCode === "generatedDate"
      ) {
        const from = doc.fromDate ? new Date(doc.fromDate) : null;
        const to = doc.toDate ? new Date(doc.toDate) : null;

        if (!from && !to) {
          // If both are empty, no error (optional filter)
          return;
        }

        if (!from) {
          errors[`${doc.id}_fromDate`] = "From Date is required";
        }

        if (!to) {
          errors[`${doc.id}_toDate`] = "To Date is required";
        }

        if (from && to && from > to) {
          errors[`${doc.id}_dateRange`] =
            "From Date cannot be greater than To Date";
        }
      }

      // Add validation for required text fields
      if (
        ["loadingAdviceNr", "documentNumber", "customerName"].includes(
          doc.actionCode,
        )
      ) {
        if (!doc.greaterThan || doc.greaterThan.trim() === "") {
          errors[`${doc.id}_${doc.actionCode}`] =
            `${doc.actionCode} is required`;
        }
      }
    });

    if (Object.keys(errors).length > 0) {
      setValidation(errors);
      return; // Stop submission
    }

    setValidation({}); // Clear errors if validation passes

    const filter = {};

    getcustomerContactPerson.forEach((doc) => {
      if (
        doc.actionCode === "createdAt" ||
        doc.actionCode === "generatedDate" ||
        doc.actionCode === "dispatchDate" ||
        doc.actionCode === "filledDate" ||
        doc.actionCode === "transportRequestDate" ||
        doc.actionCode === "openingDateTime" ||
        doc.actionCode === "purchasingDocumentDate" ||
        doc.actionCode === "cashRequestDate" ||
        doc.actionCode === "registrationDate"
      ) {
        if (doc.fromDate || doc.toDate) {
          filter[doc.actionCode] = {};

          if (doc.fromDate) {
            filter[doc.actionCode]["$gte"] = new Date(
              doc.fromDate + "T00:00:00.000Z",
            );
          }

          if (doc.toDate) {
            filter[doc.actionCode]["$lte"] = new Date(
              doc.toDate + "T23:59:59.999Z",
            );
          }
        }
      } else if (
        [
          "loadingAdviceNr",
          "documentNumber",
          "userId",
          "invoiceNr",
          "orderSchedulingNr",
          "materialDescription",
          "companyCodeDesc",
          "createdByName",
          "customerName",
          "organisationName",
          "documentNumber",
          "invoiceNr",
          "orderSchedulingNr",
          "e_WayBillNo",
          "salesOfficerName",
          "salesOfficerCode",
          "vehicleNr",
          "driverName1Code",
          "bunk",
          "companyCode",
          "rfxNr",
          "rfqType",
          "rfxHeaderStatus",
          "quotationNr",
          "productType",
          "purchasingDocumentNr",
          "organisationName",
          "cashRequestStatus",
          "truckNr",
          "vehicleRegistrationNr",
          "chassisNr",
          "engineNr",
          "contactName",
          "employeeName",
          "bunkId",
          "bunkFullName",
          "driverName",
          "bunk",
          "truckNo",
          "driverName1",
          "vehicleNr",
          "pymtPrdTypeCode",
          "pymtMode",
          "customer",
          "driverBankKey",
          "bankKey",
          "bankAccountName",
          "bankAddress",
          "bankCity",
          "bankRegion",
          "bankBranchName",
        ].includes(doc.actionCode)
      ) {
        if (doc.greaterThan) {
          const value = doc.greaterThan;
          filter[doc.actionCode] = {
            // $regex: `^${value}`,
            $regex: `.*${value}.*`,
            $options: "i",
          };
        }
      } else if (doc.actionCode === "month") {
        filter["month"] = doc.month;

        filter["year"] = doc.years;
      }
    });

    onSubmit(filter);
  };

  // else if (
  //       doc.actionCode === "documentNumber" ||
  //       doc.actionCode === "userId" ||
  //       doc.actionCode === "invoiceNr" ||
  //       doc.actionCode === "orderSchedulingNr" ||
  //       doc.actionCode === "e_WayBillNo"
  //     ) {
  //       filter[doc.actionCode] = {
  //         $gte: doc.greaterThan,
  //         $lte: doc.lessThan,
  //       };
  //     }

  //  else if (
  //       doc.actionCode === "companyCodeDesc" ||
  //       doc.actionCode === "customerName" ||
  //       doc.actionCode === "organisationName" ||
  //       doc.actionCode === "createdByName" ||
  //       doc.actionCode === "materialDescription" ||
  //       doc.actionCode === "loadingAdviceNr"
  //     ) {
  //       if (doc.greaterThan) {
  //         filter[doc.actionCode] = doc.greaterThan;
  //       }
  //       if (doc.companyCode) {
  //         filter[doc.actionCode] = doc.companyCode;
  //       }
  //       if (doc.customerName) {
  //         filter[doc.actionCode] = doc.customerName;
  //       }
  //       if (doc.organisationName) {
  //         filter[doc.actionCode] = doc.organisationName;
  //       }
  //       if (doc.materialDescription) {
  //         filter[doc.actionCode] = doc.materialDescription;
  //       }
  //     }

  // if (
  //       doc.actionCode === "createdAt" ||
  //       doc.actionCode === "generatedDate"
  //     ) {
  //       if (doc.fromDate || doc.toDate) {
  //         filter[doc.actionCode] = {};

  //         if (doc.fromDate) {
  //           filter[doc.actionCode]["$gte"] = doc.fromDate;
  //         }
  //         if (doc.toDate) {
  //           filter[doc.actionCode]["$lte"] = doc.toDate;
  //         }
  //       }
  //     }
  // console.log(">>getcustomerContactPerson", getcustomerContactPerson);
  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id,
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      action: "",
      value: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  // const handleChangeCustomerContacts = (id, fieldName, value) => {
  //   // Update state
  //   setcustomerContactPerson((prevData) =>
  //     prevData.map((doc) =>
  //       doc.id === id ? { ...doc, [fieldName]: value } : doc,
  //     ),
  //   );
  // };

  const handleChangeCustomerContacts = (id, fieldName, value) => {
    // Clear validation errors for this specific field when user starts typing/changing
    setValidation((prev) => {
      const newValidation = { ...prev };

      // Clear all validation errors for this specific document ID
      Object.keys(newValidation).forEach((key) => {
        if (key.startsWith(`${id}_`)) {
          delete newValidation[key];
        }
      });

      return newValidation;
    });

    // Update state
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
  };
  return (
    <div className="filterBox p-0 m-0 mb-2">
      {/* {error && <Alert variant="danger py-2">{error}</Alert>} */}
      <Form>
        <Form.Group as={Row} className="mb-3">
          <div className="d-flex-column justify-content-center">
            <Row className="pt-4 d-none d-lg-flex ">
              <Col xs={12} md={3} lg={3}>
                <p className="fs-6 fw-medium d-flex ms-4">Action</p>
              </Col>

              <Col xs={12} md={3} lg={3}>
                <p className="fs-6 fw-medium d-flex ms-4">Value</p>
              </Col>
            </Row>
            {getcustomerContactPerson.map((doc, index) => (
              <Row key={doc.id}>
                <Col xs={12}>
                  <hr className="mx-4 my-0 text-color-black" />
                </Col>
                <Col
                  xs={12}
                  md={3}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <ComboboxField
                    label="Filter Type"
                    placeholder="Action"
                    data={getFilterData}
                    id="action"
                    iconClassName="dropdownIcon"
                    name="action"
                    code="actionCode"
                    description="actionDesc"
                    setValue={doc?.action}
                    getvalue={setDropdownData}
                    index={doc.id}
                    onChangeValue={handleChangeCustomerContacts}
                  />
                </Col>
                {false && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        name="lessThan"
                        placeholder="Highest Nr"
                        value={doc.lessThan || ""}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "lessThan",
                            e.target.value,
                          )
                        }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        name="value"
                        placeholder="Lowest Nr"
                        value={doc.greaterThan || ""}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "greaterThan",
                            e.target.value,
                          )
                        }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                      />
                    </Col>
                  </>
                )}
                {false && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        name="textField"
                        placeholder="Text"
                        value={doc.greaterThan || ""}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "greaterThan",
                            e.target.value,
                          )
                        }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                      />
                    </Col>
                  </>
                )}

                {/* for single input field important common for all*/}
                {(doc.actionCode === "loadingAdviceNr" ||
                  doc.actionCode === "documentNumber" ||
                  doc.actionCode === "userId" ||
                  doc.actionCode === "invoiceNr" ||
                  doc.actionCode === "orderSchedulingNr" ||
                  doc.actionCode === "e_WayBillNo" ||
                  doc.actionCode === "materialDescription" ||
                  doc.actionCode === "companyCodeDesc" ||
                  doc.actionCode === "createdByName" ||
                  doc.actionCode === "customerName" ||
                  doc.actionCode === "organisationName" ||
                  doc.actionCode === "documentNumber" ||
                  doc.actionCode === "invoiceNr" ||
                  doc.actionCode === "orderSchedulingNr" ||
                  doc.actionCode === "salesOfficerName" ||
                  doc.actionCode === "salesOfficerCode" ||
                  doc.actionCode === "vehicleNr" ||
                  doc.actionCode === "driverName1Code" ||
                  doc.actionCode === "bunk" ||
                  doc.actionCode === "rfxNr" ||
                  doc.actionCode === "rfqType" ||
                  doc.actionCode === "rfxHeaderStatus" ||
                  doc.actionCode === "quotationNr" ||
                  doc.actionCode === "productType" ||
                  doc.actionCode === "purchasingDocumentNr" ||
                  doc.actionCode === "cashRequestStatus" ||
                  doc.actionCode === "truckNr" ||
                  doc.actionCode === "vehicleRegistrationNr" ||
                  doc.actionCode === "chassisNr" ||
                  doc.actionCode === "engineNr" ||
                  doc.actionCode === "employeeName" ||
                  doc.actionCode === "contactName" ||
                  doc.actionCode === "bunkId" ||
                  doc.actionCode === "driverName" ||
                  doc.actionCode === "bunk" ||
                  doc.actionCode === "truckNo" ||
                  doc.actionCode === "driverName1" ||
                  doc.actionCode === "vehicleNr" ||
                  doc.actionCode === "pymtPrdTypeCode" ||
                  doc.actionCode === "pymtMode" ||
                  doc.actionCode === "customer" ||
                  doc.actionCode === "bankKey" ||
                  doc.actionCode === "bankAccountName" ||
                  doc.actionCode === "bankAddress" ||
                  doc.actionCode === "bankCity" ||
                  doc.actionCode === "bankRegion" ||
                  doc.actionCode === "bankBranchName") && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        label="Value"
                        name="textField"
                        placeholder="Text"
                        value={doc.greaterThan || ""}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "greaterThan",
                            e.target.value,
                          )
                        }
                        error={validation[`${doc.id}_${doc.actionCode}`]}
                      />
                    </Col>
                  </>
                )}

                {false && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        name="textField"
                        placeholder="Text"
                        value={doc.greaterThan || ""}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "greaterThan",
                            e.target.value,
                          )
                        }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                      />
                    </Col>

                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label=""
                        placeholder="Action"
                        data={getCompanyCode}
                        id="companyCode"
                        iconClassName="dropdownIcon"
                        name="companyCode"
                        code="companyCode"
                        description="companyCodeDesc"
                        setValue={doc?.companyCode}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                  </>
                )}
                {false && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label=""
                        placeholder="Action"
                        data={getCustomer}
                        id="customerName"
                        iconClassName="dropdownIcon"
                        name="customerName"
                        code="customerCode"
                        description="customerNameDesc"
                        setValue={doc?.customerName}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                  </>
                )}
                {(doc.actionCode === "createdAt" ||
                  doc.actionCode === "generatedDate" ||
                  doc.actionCode === "dispatchDate" ||
                  doc.actionCode === "filledDate" ||
                  doc.actionCode === "transportRequestDate" ||
                  doc.actionCode === "openingDateTime" ||
                  doc.actionCode === "purchasingDocumentDate" ||
                  doc.actionCode === "cashRequestDate" ||
                  doc.actionCode === "registrationDate") && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        label="From Date"
                        name="fromDate"
                        placeholder="From Date"
                        value={doc.fromDate || ""}
                        type="date"
                        min={2023}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "fromDate",
                            e.target.value,
                          )
                        }
                        error={
                          validation[`${doc.id}_fromDate`] ||
                          validation[`${doc.id}_dateRange`]
                        }
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        label="To Date"
                        name="toDate"
                        placeholder="toDate"
                        value={doc.toDate || ""}
                        type="date"
                        min={2023}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "toDate",
                            e.target.value,
                          )
                        }
                        error={
                          validation[`${doc.id}_toDate`] ||
                          validation[`${doc.id}_dateRange`]
                        }
                      />
                    </Col>
                  </>
                )}
                {doc.actionCode === "month" && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label="Month"
                        placeholder="Action"
                        data={months}
                        id="month"
                        iconClassName="dropdownIcon"
                        name="month"
                        code="monthCode"
                        description="monthDesc"
                        setValue={doc?.month}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label="Year"
                        placeholder="Action"
                        data={years}
                        id="years"
                        iconClassName="dropdownIcon"
                        name="years"
                        code="yearsCode"
                        description="yearsDesc"
                        setValue={doc?.years}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                  </>
                )}

                <Col
                  xs={12}
                  md={3}
                  lg={3}
                  className="commTopButtonRightLeftPadding d-flex align-items-center"
                >
                  {index !== 0 && (
                    <Button
                      className="btnTable w-25 mt-2"
                      variant="danger"
                      // onClick={handleAddField}
                      onClick={() => deleteCustomerContactPerosn(doc.id)}
                    >
                      -
                    </Button>
                  )}
                  <Button
                    className="btnTable w-25 mt-2"
                    variant="primary"
                    // onClick={handleAddField}
                    onClick={() => addCustomerCantactPerson(doc.id)}
                  >
                    +
                  </Button>
                </Col>
                <Col
                  xs={12}
                  md={1}
                  lg={1}
                  className="commTopButtonRightLeftPadding d-flex align-items-center"
                ></Col>
              </Row>
            ))}
          </div>
          <Row>
            <Col sm={3} className="commTopButtonRightLeftPadding">
              <h6>&nbsp;</h6>
              <Button variant="primary" onClick={handleSubmit}>
                Search
              </Button>
              <Button variant="danger" onClick={handleClearAll}>
                Clear
              </Button>
              <Button variant="danger" onClick={handleCancel}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form.Group>
      </Form>
    </div>
  );
};

export default CommonFilterCustomerV2;
